import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, toHandlers as _toHandlers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-container" }
const _hoisted_2 = { class: "admin-top" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-left" }, null, -1)
const _hoisted_4 = { class: "admin-stage" }
const _hoisted_5 = { style: {"display":"flex","width":"100%","gap":"15px","margin-bottom":"16px","flex":"1"} }
const _hoisted_6 = { class: "user-accounts elevate" }
const _hoisted_7 = { style: {"margin":"0","margin-bottom":"15px"} }
const _hoisted_8 = { class: "user-account-ratio" }
const _hoisted_9 = { href: "#" }
const _hoisted_10 = { class: "site-list-item" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "name-link" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { style: {"display":"flex","gap":"15px"} }
const _hoisted_15 = { class: "site-tag" }
const _hoisted_16 = { style: {"display":"flex","gap":"15px"} }
const _hoisted_17 = { class: "site-tag" }
const _hoisted_18 = { style: {"display":"flex","gap":"15px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_btn = _resolveComponent("imdex-btn")!
  const _component_imdex_data_usage = _resolveComponent("imdex-data-usage")!
  const _component_imdex_tooltip = _resolveComponent("imdex-tooltip")!
  const _component_imdex_table = _resolveComponent("imdex-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_imdex_btn, {
        style: {"margin-right":"15px","font-size":"25pt"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/ssa'))),
        text: "",
        compact: "",
        secondary: ""
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.$t("sitesMgmt.title")) + " ", 1),
      _createVNode(_component_imdex_btn, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/site/create'))),
        style: {"margin-left":"auto"},
        secondary: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("sitesMgmt.createSite")), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_imdex_data_usage, {
          style: {"flex":"1"},
          items: _ctx.sites,
          containerSize: _ctx.containerSize
        }, null, 8, ["items", "containerSize"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t("sitesMgmt.userAccounts")), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.totalUsers), 1),
          _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$t("sitesMgmt.getMoreAccounts")), 1)
        ])
      ]),
      _createVNode(_component_imdex_table, {
        loading: _ctx.tableLoading,
        tableData: _ctx.tableData,
        class: "elevate admin-table-container"
      }, {
        "h-name": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("sitesMgmt.name")), 1)
        ]),
        "h-country": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("sitesMgmt.country")), 1)
        ]),
        "h-size": _withCtx(() => [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("sitesMgmt.dataUsage")), 1)
        ]),
        "h-assigned_users": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("sitesMgmt.assignedUsers")), 1)
        ]),
        "h-created_at": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("sitesMgmt.createdAt")), 1)
        ]),
        name: _withCtx((prop) => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              onClick: ($event: any) => (_ctx.$router.push('/site/' + prop.row.id)),
              style: {"display":"flex","cursor":"pointer","gap":"15px","align-items":"center","overflow":"hidden"}
            }, [
              _createElementVNode("div", {
                class: "color-block",
                style: _normalizeStyle(`background:${prop.row.color};min-width:30px`)
              }, null, 4),
              _createVNode(_component_imdex_tooltip, {
                nudgeY: -10,
                class: "name-tooltip"
              }, {
                activator: _withCtx((on) => [
                  _createElementVNode("div", _toHandlers(on), [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(prop.row.name), 1)
                  ], 16)
                ]),
                tooltip: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: prop.row.name
                  }, null, 8, _hoisted_13)
                ]),
                _: 2
              }, 1024)
            ], 8, _hoisted_11)
          ])
        ]),
        assigned_users: _withCtx((prop) => [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(prop.row.assigned_users), 1)
          ])
        ]),
        size: _withCtx((prop) => [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formatBytes(prop.row.size)), 1)
          ])
        ]),
        created_at: _withCtx((prop) => [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", null, _toDisplayString(_ctx.moment(prop.row.created_at).format("MM/DD/YYYY HH:mm")), 1)
          ])
        ]),
        _: 1
      }, 8, ["loading", "tableData"])
    ])
  ]))
}